import React from 'react';
import I18n from 'i18n-js';
import { Button } from 'grab-ui';
import _get from 'lodash/get';
import {
  SCRIBE_SHOPIFY_STATES,
  SCRIBE_SHOPIFY_EVENTS,
} from 'applications/scribe/instrumentations/track';
import ShopifyTrackEventContext from 'views/v2/shopify-home/track-event';
import { ShopAddressSettingsModalContext } from './shop-address-settings-modal-context';
import ShopAddressSettingsModal from './shop-address-settings-modal';
import styles from './address-card.less';

const AddressCard = () => {
  const trackCtx = React.useContext(ShopifyTrackEventContext);
  const { pickUpAddress, setShowModal } = React.useContext(
    ShopAddressSettingsModalContext,
  );

  const { shopifyLocation, grabPoi, metaData, verified } = pickUpAddress;
  const contact = metaData && metaData.contact ? metaData.contact : null;

  const fireEditPickUpAddressTrackEvent = () => {
    trackCtx.fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_SETTINGS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.EDIT_PICKUP_ADDRESS,
    });
  };

  const clickEditHandler = () => {
    fireEditPickUpAddressTrackEvent();
    setShowModal(true);
  };

  const addressToDisplay = verified
    ? _get(grabPoi, 'address')
    : _get(shopifyLocation, 'address1');

  return (
    <div className={styles.AddressCard}>
      <p className={styles.Label}>{shopifyLocation.name}</p>
      {contact && (
        <p className={styles.ContactInfo}>
          {contact.name && <span>{contact.name}</span>}
          {contact.name && contact.phone && <span> • </span>}
          {contact.phone && <span>{contact.phone}</span>}
        </p>
      )}
      {addressToDisplay && (
        <p className={styles.AddressInfo}>{addressToDisplay}</p>
      )}
      {(!grabPoi || !grabPoi.address || !verified) && (
        <p
          className={styles.ErrorMessage}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: I18n.t(
              'shopify.settings.addressSettingsSection.addressCard.addressNotFound',
            ),
          }}
        />
      )}
      <div className={styles.ActionButtonsContainer}>
        <Button
          className={styles.ActionButton}
          type="link"
          onClick={clickEditHandler}
        >
          {I18n.t('v2.commonButton.edit')}
        </Button>
      </div>
      <ShopAddressSettingsModal />
    </div>
  );
};

export default AddressCard;
